import { render, staticRenderFns } from "./OppregLandingForm.vue?vue&type=template&id=685c108e&scoped=true&"
import script from "./OppregLandingForm.vue?vue&type=script&lang=js&"
export * from "./OppregLandingForm.vue?vue&type=script&lang=js&"
import style0 from "./OppregLandingForm.vue?vue&type=style&index=0&id=685c108e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c108e",
  null
  
)

export default component.exports